import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
var FontAwesomeProIcon = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var icon = _ref.icon,
      type = _ref.type,
      props = _objectWithoutPropertiesLoose(_ref, ["icon", "type"]);

  var types = {
    solid: 'fas',
    light: 'fal',
    brand: 'fab',
    regular: 'far'
  };

  if (!icon) {
    return /*#__PURE__*/React.createElement("p", null, "You need to provide an ", /*#__PURE__*/React.createElement("strong", null, "icon name"));
  }

  return /*#__PURE__*/React.createElement(FontAwesomeIcon, Object.assign({
    forwardedRef: ref,
    icon: [types[type], icon]
  }, props));
});
FontAwesomeProIcon.defaultProps = {
  type: 'solid'
};
export default FontAwesomeProIcon;